import { RouteName } from "constant/routeNames";
import React from "react";
import { useNavigate } from "react-router-dom";
import { MiniPackagesResponse } from "services/subscription/types";
import { displayTimeFormat } from "utils/helperFuncs";

interface PackageCTACard {
  selectedPackage: MiniPackagesResponse;
}

const PackageDetailsCtaCard = ({ selectedPackage }: PackageCTACard) => {
  const navigate = useNavigate();
  return (
    <div className="mx-auto mt-14 w-full max-w-[768px] rounded-[26px] border border-white/5 bg-[radial-gradient(circle_at_top,#191E2A_0%,#0B0D14_52%,#06070C_100%)] px-6 py-10 text-center md:px-10">
      <h2 className="text-5xl font-extrabold text-white">Start Adventure</h2>
      <p className="mx-auto mt-3 max-w-[480px] text-base font-normal text-white/70">
        Add the Kids Pack to your current subscription for just $
        {selectedPackage?.price}/
        {displayTimeFormat(selectedPackage?.plan_period_format)}. Cancel
        anytime, no strings attached.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
        <div className="text-start">
          <p className="text-[12px] uppercase font-bold tracking-[0.15em] text-white/60">
            {displayTimeFormat(selectedPackage.plan_period_format)}ly
          </p>
          <p className="text-3xl font-extrabold text-white">
            ${selectedPackage?.price}
            <span className="text-sm font-normal text-white/60">
              /{displayTimeFormat(selectedPackage.plan_period_format)}
            </span>
          </p>
        </div>
        <button
          className="px-12 py-4 text-base font-bold text-black bg-white rounded-full"
          onClick={() =>
            navigate(RouteName.SubscriptionPlanCheckout, {
              state: { plan: selectedPackage },
            })
          }
        >
          Subscribe Now
        </button>
      </div>
    </div>
  );
};

export default PackageDetailsCtaCard;
